// extracted by mini-css-extract-plugin
export default {"row":"Earning_row__SrpAU","col":"Earning_col__BnHrP","card":"Earning_card__120w9"};